<template>
  <div
    v-if="text"
    class="help-div"
    :title="text"
  >
    <font-awesome-icon
      icon="info-circle"
      class="help-icon"
    />
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
  },
};
</script>

<style>
.help-div {
  display: inline-block;
}
.help-icon {
  cursor: help;
  margin-left: 0.25em;
}
</style>
